import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { ButtonTypes } from '@app/infrastructure/buttons/button/Button-models';

@Component({
	selector: 'app-button',
	templateUrl: './button.component.html',
	styleUrls: ['./button.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.Emulated,
})
export class ButtonComponent {
	@Input() public isSecondary: boolean;
	@Input() public type: ButtonTypes = ButtonTypes.button;
	@Input() public isPrimary: boolean;
	@Input() public isWhite: boolean;
	@Input() public isWhiteBorder: boolean;
	@Input() public isGreen: boolean;
	@Input() public isSmall: boolean;
	@Input() public isInfo: boolean;
	@Input() public isRed: boolean;

	@Input() disabled = false;
	@Output() clickHandler: EventEmitter<MouseEvent> = new EventEmitter<MouseEvent>();
}
